import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';
import PlanLimitBanner from './PlanLimitBanner';
import SupportBanner from './SupportBanner';
import SiteFooter from './SiteFooter';

const AppLayout = () => (
  <div className="app-shell">
    <Navbar />
    <div className="app-shell-content">
      <SupportBanner />
      <PlanLimitBanner />
      <main className="app-main">
        <Outlet />
      </main>
      <SiteFooter />
    </div>
  </div>
);

export default AppLayout;
